import React from 'react';
import { Clock, DollarSign, User, Wallet } from 'lucide-react';
import { EmployeeValueOutputs as EmployeeValueData } from '../../types/calculator';
import { MetricCard } from '../ui/MetricCard';
import { Card } from '../ui/Card';
import { formatCurrency, formatHours, formatFTE } from '../../utils/formatters';

interface EmployeeValueOutputsProps {
  data: EmployeeValueData;
}

export const EmployeeValueOutputs: React.FC<EmployeeValueOutputsProps> = ({ data }) => {
  return (
    <Card gradient className="h-full lg:py-8">
      <h3 className="text-lg font-serif font-semibold text-offblack mb-4 flex items-center gap-2">
        <DollarSign className="w-5 h-5 text-orange" />
        Employee Value Proposition
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <MetricCard
          icon={Clock}
          label="Connection Time"
          value={data.timeSavedHours}
          formatter={formatHours}
          color="orange"
        />

        <MetricCard
          icon={Wallet}
          label="Employee Savings"
          value={data.employeeSavings}
          formatter={formatCurrency}
          color="emerald"
        />

        <MetricCard
          icon={DollarSign}
          label="Productivity Savings"
          value={data.productivityValue}
          formatter={formatCurrency}
          color="emerald"
        />

        <MetricCard
          icon={User}
          label="Annualised FTE"
          value={data.fteRecovered}
          formatter={formatFTE}
          color="sky"
        />
      </div>
    </Card>
  );
};
